// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floor Plan Page - Tavern Theme */

.floor-plan-page {
  /* background inherited from body wood texture */
}

.floor-plan-page .ttbPageTitle {
  color: var(--color-fire-500);
  font-family: var(--font-heading);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.floor-plan-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: var(--space-3);
  padding: var(--space-4);
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--color-fire-600);
}

.floor-plan-header .ttbPageTitle {
  white-space: nowrap;
}

.floor-plan-header .floor-plan-create-button {
  font-size: 14px;
  padding: 10px 16px;
  height: auto;
  min-width: auto;
  white-space: nowrap;
  width: auto;
}

.floor-plan-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.floor-plan-map-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/*
 * Sits in the existing gap between the calendar and the map (calendar margin + flex gap + frame margin),
 * out of flow, so showing it never changes the distance between them.
 */
.floor-plan-guest-notice {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(-1 * (var(--space-2) + var(--space-3)));
  /* + the 12px top margin of .ttbFloorPlanFrame, so the text is centred in the visible gap */
  height: calc(var(--space-2) + var(--space-3) + 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 1;
  color: var(--color-parchment-300);
  pointer-events: none;
}

/* ---------- Calendar (FloorPlan only) ---------- */

.calendar-container {
  background: var(--color-wood-800);
  border: 4px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  margin-bottom: var(--space-2);
  box-shadow: var(--shadow-lg);
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-4);
}

.calendar-title {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-parchment-100);
}

.calendar-title-center {
  flex: 1;
  text-align: center;
}

.calendar-controls {
  display: flex;
  gap: var(--space-2);
}

.calendar-month-header {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-parchment-100);
  text-align: center;
  margin-bottom: var(--space-3);
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.calendar-month-toggle {
  width: 100%;
  margin-top: var(--space-3);
}

.calendar-toggle {
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-md);
  padding: var(--space-2) var(--space-3);
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-sm);
}

.calendar-toggle:hover {
  background: var(--color-fire-500);
  transform: translateY(-1px);
}

.calendar-nav-arrow {
  padding: var(--space-2) var(--space-3);
  background: var(--color-wood-600);
  border: 2px solid var(--color-wood-700);
  color: var(--color-parchment-100);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.calendar-nav-arrow:hover {
  background: var(--color-fire-600);
  border-color: var(--color-fire-600);
  transform: translateY(-1px);
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: var(--space-2);
}

.calendar-day {
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  padding: var(--space-2);
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.calendar-day:hover {
  border-color: var(--color-fire-500);
  background: var(--color-wood-600);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(184, 71, 14, 0.3);
}

/* Текущий день - голубая рамка */
.calendar-day.today {
  border-color: var(--color-info-500);
  border-width: 3px;
  box-shadow: 0 0 8px rgba(74, 107, 138, 0.5);
}

/* Выбранный день - оранжевый (fire) фон */
.calendar-day.active {
  background: var(--color-fire-600);
  border-color: var(--color-fire-700);
  border-width: 3px;
  box-shadow: 0 4px 12px rgba(184, 71, 14, 0.5);
}

.calendar-day.active .day-label,
.calendar-day.active .day-number {
  color: var(--color-parchment-100);
}

/* Выходные дни - тёплый красноватый оттенок */
.calendar-day.weekend {
  background: var(--color-wood-600);
  border-color: var(--color-danger-600);
}

.calendar-day.weekend .day-label,
.calendar-day.weekend .day-number {
  color: var(--color-warning-500);
}

/* Выходной + выбранный */
.calendar-day.weekend.active {
  background: var(--color-fire-600);
  border-color: var(--color-fire-700);
}

.calendar-day.weekend.active .day-label,
.calendar-day.weekend.active .day-number {
  color: var(--color-parchment-100);
}

/* Прошедшие дни */
.calendar-day.past {
  opacity: 0.5;
}

/* Дни вне текущего месяца */
.calendar-day.out-month {
  opacity: 0.3;
}

.day-label {
  font-size: 11px;
  color: var(--color-parchment-300);
  margin-bottom: 2px;
  font-weight: 600;
}

.day-number {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-parchment-100);
}

/* Day participation indicators */
.day-indicators {
  display: flex;
  gap: 3px;
  justify-content: center;
  min-height: 6px;
}

.day-indicator {
  width: 6px;
  height: 6px;
  border-radius: 2px;
}

.day-indicator-confirmed {
  background-color: var(--color-success-500);
}

.day-indicator-pending {
  background-color: var(--color-warning-500);
}

/* Legacy styles */
.ttbCalendarHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
}

.ttbCalendarGrid {
	margin-top: 10px;
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 8px;
}

.ttbCalendarWeekdayLabel {
	text-align: center;
	font-size: 12px;
	color: var(--app-hint);
	font-weight: 700;
}

.ttbCalendarMonthDay {
	height: 44px;
	border-radius: 10px;
	border: 1px solid var(--app-separator);
	background: transparent;
	color: var(--app-text);
	font-weight: 700;
}

.ttbCalendarWeekDay {
	height: 52px;
	border-radius: 12px;
	border: 1px solid var(--app-separator);
	background: transparent;
	color: var(--app-text);
	font-weight: 700;
	padding: 0;
}

.ttbCalendarDaySelected {
	border: 2px solid var(--app-button);
	background: var(--app-surface);
}

.ttbCalendarDayWeekend {
	color: var(--app-warning);
}

.ttbCalendarDayOutMonth {
	opacity: 0.5;
}

.ttbCalendarDayPast {
	opacity: 0.55;
	color: var(--app-hint);
}

.ttbCalendarDayTodayStrong {
	font-weight: 900;
	border-color: var(--app-button);
}

.ttbCalendarWeekDow {
	font-size: 12px;
	opacity: 0.8;
}

.ttbCalendarWeekDom {
	font-size: 16px;
}

.ttbCalendarTodayDot {
	font-size: 10px;
	color: transparent;
}

.ttbCalendarTodayDotActive {
	color: var(--app-button);
}

.ttbCalendarModeToggle {
	margin-top: 12px;
}

@media (max-width: 425px) {

	.ttbShellMain{
		overflow: auto;
	}

	.day-indicators {
		gap: 2px;
	}

	.day-indicator {
		width: 5px;
		height: 5px;
	}

	.calendar-container {
		padding: var(--space-3);
	}

	.calendar-title {
		font-size: 12px;
		line-height: 1.2;
		margin: 0 var(--space-1);	
	}

	.calendar-month-header {
		font-size: 18px;
	}

	.calendar-toggle {
		font-size: 12px;
		padding: 6px 10px;
	}

	.calendar-nav-arrow {
		font-size: 14px;
		padding: 6px 10px;
	}

	.calendar-days {
		gap: var(--space-1);
	}

	.calendar-day {
		min-height: 52px;
		padding: var(--space-1);
	}

	.day-label {
		font-size: 10px;
	}

	.day-number {
		font-size: 16px;
	}

	.ttbCalendarWeekdayLabel {
		font-size: 11px;
	}

	.ttbCalendarWeekDow {
		font-size: 11px;
	}

	.ttbCalendarWeekDom {
		font-size: 14px;
	}
}

/* ---------- Floor plan-only controls ---------- */

.ttbButtonPrimaryWide {
	height: 44px;
	width: 100%;
	border-radius: 12px;
	border: none;
	background: var(--app-button);
	color: var(--app-button-text);
	font-weight: 800;
}

.ttbFloorPlanHint {
	color: var(--app-hint);
	font-size: 13px;
}

.ttbFloorPlanFrame {
	margin-top: 12px;
	border-radius: 12px;
	border: 4px solid var(--color-wood-700);
	overflow: hidden;
	background: var(--color-parchment-100);
	
	/* Parchment texture */
	background-image: 
		radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
		radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
		radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
		repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
		repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
	
	padding: var(--space-2);
}

/* SVG план помещений - адаптивный */
.ttbFloorPlanSvg {
	width: 100%;
	height: auto;
	display: block;
	max-width: 1200px;
	margin: 0 auto;
}

.ttbFloorPlanViewport {
  background: var(--color-parchment-100);
  
  /* Parchment texture */
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
}

/* Map Container */
.map-container {
  background: var(--color-parchment-100);
  
  /* Parchment texture */
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
  
  border: 4px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  padding: var(--space-4);
  min-height: 400px;
  position: relative;
  overflow: hidden;
}

.ttbFloorPlanViewport {
  width: 100%;
  aspect-ratio: 360 / 260;
  background: var(--app-bg);
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.ttbFloorPlanCanvas {
	position: absolute;
	inset: 0;
	transform-origin: 0 0;
}

/* Комнаты */
.ttbFloorPlanRoomDvor {
	position: absolute;
	left: 2%;
	top: 8%;
	width: 48%;
	height: 88%;
	border-radius: 12px;
	background: rgba(245, 239, 231, 0.3);
	border: 2px solid var(--color-wood-600);
}

.ttbFloorPlanRoomTavern {
	position: absolute;
	left: 52%;
	top: 8%;
	width: 46%;
	height: 88%;
	border-radius: 12px;
	background: rgba(245, 239, 231, 0.3);
	border: 2px solid var(--color-wood-600);
}

/* Дверь между комнатами */
.ttbFloorPlanDoor {
	position: absolute;
	left: 49%;
	top: 35%;
	width: 4%;
	height: 12%;
	background: var(--color-wood-700);
	border: 2px solid var(--color-wood-800);
	border-radius: 6px;
	z-index: 2;
}

.ttbFloorPlanDoor::before {
	content: '🚪';
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 20px;
}

.ttbFloorPlanRoomLabel {
	position: absolute;
	font-size: 14px;
	color: var(--color-wood-700);
	font-weight: 700;
	font-family: var(--font-heading);
	user-select: none;
	z-index: 1;
}

.ttbFloorPlanRoomLabelDvor {
	left: 15%;
	top: 5%;
}

.ttbFloorPlanRoomLabelTavern {
	left: 65%;
	bottom: 8%;
}

.ttbFloorPlanResource {
	position: absolute;
	border-radius: 10px;
	background: rgba(245, 239, 231, 0.8);
	border: 3px solid var(--app-success);
	padding: 4px;
	cursor: pointer;
	color: var(--app-text);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	transition: all var(--transition-fast);
	z-index: 3;
}

.ttbFloorPlanResource:hover {
	transform: scale(1.05);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ttbFloorPlanResource--red {
	border-color: var(--app-danger);
	background: rgba(168, 52, 42, 0.15);
}

.ttbFloorPlanResource--yellow {
	border-color: var(--app-warning);
	background: rgba(212, 167, 74, 0.15);
}

.ttbFloorPlanResource--green {
	border-color: var(--app-success);
	background: rgba(74, 124, 89, 0.15);
}

.ttbFloorPlanResourceIcon {
	font-size: 32px;
	line-height: 1;
	position: relative;
}

/* Стол со стульями - вид сверху */
.table-with-chairs-big,
.table-with-chairs-small {
	width: 50px;
	height: 50px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Центральный стол */
.table-center {
	width: 24px;
	height: 24px;
	background: var(--color-wood-600);
	border: 2px solid var(--color-wood-800);
	border-radius: 4px;
	position: relative;
	z-index: 2;
}

/* Большой стол - 6 стульев вокруг */
.table-with-chairs-big::before,
.table-with-chairs-big::after {
	content: '';
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--color-wood-700);
	border: 1px solid var(--color-wood-900);
	border-radius: 2px;
}

/* Стулья слева и справа */
.table-with-chairs-big::before {
	left: 2px;
	top: 50%;
	transform: translateY(-50%);
	box-shadow: 0 -12px 0 0 var(--color-wood-700),
	            0 12px 0 0 var(--color-wood-700);
}

/* Стулья сверху и снизу */
.table-with-chairs-big::after {
	right: 2px;
	top: 50%;
	transform: translateY(-50%);
	box-shadow: 0 -12px 0 0 var(--color-wood-700),
	            0 12px 0 0 var(--color-wood-700);
}

/* Маленький стол - 4 стула */
.table-with-chairs-small::before,
.table-with-chairs-small::after {
	content: '';
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--color-wood-700);
	border: 1px solid var(--color-wood-900);
	border-radius: 2px;
}

/* Стулья слева и справа */
.table-with-chairs-small::before {
	left: 4px;
	top: 50%;
	transform: translateY(-50%);
}

.table-with-chairs-small::after {
	right: 4px;
	top: 50%;
	transform: translateY(-50%);
}

/* Дополнительные стулья сверху и снизу через box-shadow */
.table-with-chairs-small .table-center::before,
.table-with-chairs-small .table-center::after {
	content: '';
	position: absolute;
	width: 8px;
	height: 8px;
	background: var(--color-wood-700);
	border: 1px solid var(--color-wood-900);
	border-radius: 2px;
	left: 50%;
	transform: translateX(-50%);
}

.table-with-chairs-small .table-center::before {
	top: -14px;
}

.table-with-chairs-small .table-center::after {
	bottom: -14px;
}

.ttbFloorPlanResourceCount {
	font-size: 18px;
	font-weight: 800;
	line-height: 1;
	color: var(--color-fire-600);
}

.ttbFloorPlanResourceName {
	font-size: 9px;
	color: var(--color-wood-700);
	font-weight: 600;
	line-height: 1;
	text-align: center;
}

/* Layout positions based on actual floor plan (360x260 design space) */
/* Левая комната (Двор), правая комната (Таверна), дверь посередине */

/* ДВОР - левая комната */
/* Стол 4 - вверху слева */
.ttbFloorPlanResource--table_game_4 {
	left: 5.5556%;      /* 20 / 360 */
	top: 11.5385%;      /* 30 / 260 */
	width: 19.4444%;    /* 70 / 360 */
	height: 19.2308%;   /* 50 / 260 */
}

/* Стол настольного тенниса - слева внизу */
.ttbFloorPlanResource--table_ping_pong_1 {
	left: 5.5556%;      /* 20 / 360 */
	top: 53.8462%;      /* 140 / 260 */
	width: 13.8889%;    /* 50 / 360 */
	height: 30.7692%;   /* 80 / 260 */
}

/* Зона фехтования - центр двора */
.ttbFloorPlanResource--zone_fencing_1 {
	left: 26.3889%;     /* 95 / 360 */
	top: 46.1538%;      /* 120 / 260 */
	width: 22.2222%;    /* 80 / 360 */
	height: 26.9231%;   /* 70 / 260 */
}

/* ТАВЕРНА - правая комната */
/* Стол 1 - вверху слева */
.ttbFloorPlanResource--table_game_1 {
	left: 55.5556%;     /* 200 / 360 */
	top: 11.5385%;      /* 30 / 260 */
	width: 18.0556%;    /* 65 / 360 */
	height: 19.2308%;   /* 50 / 260 */
}

/* Стол 2 - вверху справа */
.ttbFloorPlanResource--table_game_2 {
	left: 76.3889%;     /* 275 / 360 */
	top: 11.5385%;      /* 30 / 260 */
	width: 18.0556%;    /* 65 / 360 */
	height: 19.2308%;   /* 50 / 260 */
}

/* Стол 3 - под столом 2 (маленький) */
.ttbFloorPlanResource--table_game_3 {
	left: 79.1667%;     /* 285 / 360 */
	top: 46.1538%;      /* 120 / 260 */
	width: 12.5%;       /* 45 / 360 */
	height: 13.4615%;   /* 35 / 260 */
}

/* Legend */
.legend {
  display: flex;
  gap: var(--space-4);
  justify-content: center;
  margin-top: var(--space-4);
  padding: var(--space-3);
  background: rgba(245, 239, 231, 0.5);
  border-radius: var(--radius-md);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: 13px;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid var(--color-wood-700);
}

.legend-available {
  background: rgba(74, 124, 89, 0.3);
}

.legend-partial {
  background: rgba(212, 167, 74, 0.3);
}

.legend-occupied {
  background: rgba(168, 52, 42, 0.3);
}

@media (max-width: 425px) {
	.ttbFloorPlanHint {
		font-size: 12px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/FloorPlan/FloorPlanPage.css"],"names":[],"mappings":"AAEA,mCAAmC;;AAEnC;EACE,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,iDAAiD;EACjD,2FAA2F;EAC3F,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,oDAAoD;;AAEpD;EACE,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,8CAA8C;AAC9C;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,qCAAqC;CACrC,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,sCAAsC;CACtC,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,sCAAsC;CACtC,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,mCAAmC;CACnC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC;EACC,cAAc;CACf;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,UAAU;EACV,WAAW;CACZ;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;CACzB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA,mDAAmD;;AAEnD;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,6BAA6B;CAC7B,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uCAAuC;CACvC,gBAAgB;CAChB,sCAAsC;;CAEtC,sBAAsB;CACtB;;;;;gIAK+H;;CAE/H,uBAAuB;AACxB;;AAEA,oCAAoC;AACpC;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,cAAc;AACf;;AAEA;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;kIAKgI;AAClI;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;kIAKgI;;EAEhI,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,qBAAqB;AACtB;;AAEA,YAAY;AACZ;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,oCAAoC;CACpC,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,oCAAoC;CACpC,uCAAuC;AACxC;;AAEA,0BAA0B;AAC1B;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,SAAS;CACT,WAAW;CACX,iCAAiC;CACjC,uCAAuC;CACvC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,4BAA4B;CAC5B,gBAAgB;CAChB,gCAAgC;CAChC,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,SAAS;CACT,OAAO;AACR;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oCAAoC;CACpC,oCAAoC;CACpC,YAAY;CACZ,eAAe;CACf,sBAAsB;CACtB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;CACR,sCAAsC;CACtC,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,yCAAyC;AAC1C;;AAEA;CACC,+BAA+B;CAC/B,mCAAmC;AACpC;;AAEA;CACC,gCAAgC;CAChC,oCAAoC;AACrC;;AAEA;CACC,gCAAgC;CAChC,mCAAmC;AACpC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA,kCAAkC;AAClC;;CAEC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA,qBAAqB;AACrB;CACC,WAAW;CACX,YAAY;CACZ,iCAAiC;CACjC,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA,oCAAoC;AACpC;;CAEC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,iCAAiC;CACjC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA,0BAA0B;AAC1B;CACC,SAAS;CACT,QAAQ;CACR,2BAA2B;CAC3B;6CAC4C;AAC7C;;AAEA,0BAA0B;AAC1B;CACC,UAAU;CACV,QAAQ;CACR,2BAA2B;CAC3B;6CAC4C;AAC7C;;AAEA,6BAA6B;AAC7B;;CAEC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,iCAAiC;CACjC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA,0BAA0B;AAC1B;CACC,SAAS;CACT,QAAQ;CACR,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,QAAQ;CACR,2BAA2B;AAC5B;;AAEA,0DAA0D;AAC1D;;CAEC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,iCAAiC;CACjC,uCAAuC;CACvC,kBAAkB;CAClB,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,4BAA4B;CAC5B,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA,uEAAuE;AACvE,qEAAqE;;AAErE,yBAAyB;AACzB,0BAA0B;AAC1B;CACC,aAAa,OAAO,aAAa;CACjC,aAAa,OAAO,aAAa;CACjC,eAAe,KAAK,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,2CAA2C;AAC3C;CACC,aAAa,OAAO,aAAa;CACjC,aAAa,OAAO,cAAc;CAClC,eAAe,KAAK,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,kCAAkC;AAClC;CACC,cAAc,MAAM,aAAa;CACjC,aAAa,OAAO,cAAc;CAClC,eAAe,KAAK,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,6BAA6B;AAC7B,0BAA0B;AAC1B;CACC,cAAc,MAAM,cAAc;CAClC,aAAa,OAAO,aAAa;CACjC,eAAe,KAAK,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,2BAA2B;AAC3B;CACC,cAAc,MAAM,cAAc;CAClC,aAAa,OAAO,aAAa;CACjC,eAAe,KAAK,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,sCAAsC;AACtC;CACC,cAAc,MAAM,cAAc;CAClC,aAAa,OAAO,cAAc;CAClC,YAAY,QAAQ,aAAa;CACjC,gBAAgB,IAAI,aAAa;AAClC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":["@import '../_base.css';\n\n/* Floor Plan Page - Tavern Theme */\n\n.floor-plan-page {\n  /* background inherited from body wood texture */\n}\n\n.floor-plan-page .ttbPageTitle {\n  color: var(--color-fire-500);\n  font-family: var(--font-heading);\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.floor-plan-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  padding-bottom: var(--space-3);\n  border-bottom: 2px solid var(--color-fire-600);\n}\n\n.floor-plan-header .ttbPageTitle {\n  white-space: nowrap;\n}\n\n.floor-plan-header .floor-plan-create-button {\n  font-size: 14px;\n  padding: 10px 16px;\n  height: auto;\n  min-width: auto;\n  white-space: nowrap;\n  width: auto;\n}\n\n.floor-plan-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.floor-plan-map-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/*\n * Sits in the existing gap between the calendar and the map (calendar margin + flex gap + frame margin),\n * out of flow, so showing it never changes the distance between them.\n */\n.floor-plan-guest-notice {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(-1 * (var(--space-2) + var(--space-3)));\n  /* + the 12px top margin of .ttbFloorPlanFrame, so the text is centred in the visible gap */\n  height: calc(var(--space-2) + var(--space-3) + 12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  line-height: 1;\n  color: var(--color-parchment-300);\n  pointer-events: none;\n}\n\n/* ---------- Calendar (FloorPlan only) ---------- */\n\n.calendar-container {\n  background: var(--color-wood-800);\n  border: 4px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  margin-bottom: var(--space-2);\n  box-shadow: var(--shadow-lg);\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-4);\n}\n\n.calendar-title {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n}\n\n.calendar-title-center {\n  flex: 1;\n  text-align: center;\n}\n\n.calendar-controls {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.calendar-month-header {\n  font-family: var(--font-heading);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  text-align: center;\n  margin-bottom: var(--space-3);\n  text-transform: capitalize;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.calendar-month-toggle {\n  width: 100%;\n  margin-top: var(--space-3);\n}\n\n.calendar-toggle {\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-md);\n  padding: var(--space-2) var(--space-3);\n  font-family: var(--font-heading);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-sm);\n}\n\n.calendar-toggle:hover {\n  background: var(--color-fire-500);\n  transform: translateY(-1px);\n}\n\n.calendar-nav-arrow {\n  padding: var(--space-2) var(--space-3);\n  background: var(--color-wood-600);\n  border: 2px solid var(--color-wood-700);\n  color: var(--color-parchment-100);\n  border-radius: var(--radius-md);\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.calendar-nav-arrow:hover {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-600);\n  transform: translateY(-1px);\n}\n\n.calendar-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: var(--space-2);\n}\n\n.calendar-day {\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  padding: var(--space-2);\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-height: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.calendar-day:hover {\n  border-color: var(--color-fire-500);\n  background: var(--color-wood-600);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(184, 71, 14, 0.3);\n}\n\n/* Текущий день - голубая рамка */\n.calendar-day.today {\n  border-color: var(--color-info-500);\n  border-width: 3px;\n  box-shadow: 0 0 8px rgba(74, 107, 138, 0.5);\n}\n\n/* Выбранный день - оранжевый (fire) фон */\n.calendar-day.active {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-700);\n  border-width: 3px;\n  box-shadow: 0 4px 12px rgba(184, 71, 14, 0.5);\n}\n\n.calendar-day.active .day-label,\n.calendar-day.active .day-number {\n  color: var(--color-parchment-100);\n}\n\n/* Выходные дни - тёплый красноватый оттенок */\n.calendar-day.weekend {\n  background: var(--color-wood-600);\n  border-color: var(--color-danger-600);\n}\n\n.calendar-day.weekend .day-label,\n.calendar-day.weekend .day-number {\n  color: var(--color-warning-500);\n}\n\n/* Выходной + выбранный */\n.calendar-day.weekend.active {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-700);\n}\n\n.calendar-day.weekend.active .day-label,\n.calendar-day.weekend.active .day-number {\n  color: var(--color-parchment-100);\n}\n\n/* Прошедшие дни */\n.calendar-day.past {\n  opacity: 0.5;\n}\n\n/* Дни вне текущего месяца */\n.calendar-day.out-month {\n  opacity: 0.3;\n}\n\n.day-label {\n  font-size: 11px;\n  color: var(--color-parchment-300);\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n\n.day-number {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n}\n\n/* Day participation indicators */\n.day-indicators {\n  display: flex;\n  gap: 3px;\n  justify-content: center;\n  min-height: 6px;\n}\n\n.day-indicator {\n  width: 6px;\n  height: 6px;\n  border-radius: 2px;\n}\n\n.day-indicator-confirmed {\n  background-color: var(--color-success-500);\n}\n\n.day-indicator-pending {\n  background-color: var(--color-warning-500);\n}\n\n/* Legacy styles */\n.ttbCalendarHeader {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n}\n\n.ttbCalendarGrid {\n\tmargin-top: 10px;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(7, 1fr);\n\tgap: 8px;\n}\n\n.ttbCalendarWeekdayLabel {\n\ttext-align: center;\n\tfont-size: 12px;\n\tcolor: var(--app-hint);\n\tfont-weight: 700;\n}\n\n.ttbCalendarMonthDay {\n\theight: 44px;\n\tborder-radius: 10px;\n\tborder: 1px solid var(--app-separator);\n\tbackground: transparent;\n\tcolor: var(--app-text);\n\tfont-weight: 700;\n}\n\n.ttbCalendarWeekDay {\n\theight: 52px;\n\tborder-radius: 12px;\n\tborder: 1px solid var(--app-separator);\n\tbackground: transparent;\n\tcolor: var(--app-text);\n\tfont-weight: 700;\n\tpadding: 0;\n}\n\n.ttbCalendarDaySelected {\n\tborder: 2px solid var(--app-button);\n\tbackground: var(--app-surface);\n}\n\n.ttbCalendarDayWeekend {\n\tcolor: var(--app-warning);\n}\n\n.ttbCalendarDayOutMonth {\n\topacity: 0.5;\n}\n\n.ttbCalendarDayPast {\n\topacity: 0.55;\n\tcolor: var(--app-hint);\n}\n\n.ttbCalendarDayTodayStrong {\n\tfont-weight: 900;\n\tborder-color: var(--app-button);\n}\n\n.ttbCalendarWeekDow {\n\tfont-size: 12px;\n\topacity: 0.8;\n}\n\n.ttbCalendarWeekDom {\n\tfont-size: 16px;\n}\n\n.ttbCalendarTodayDot {\n\tfont-size: 10px;\n\tcolor: transparent;\n}\n\n.ttbCalendarTodayDotActive {\n\tcolor: var(--app-button);\n}\n\n.ttbCalendarModeToggle {\n\tmargin-top: 12px;\n}\n\n@media (max-width: 425px) {\n\n\t.ttbShellMain{\n\t\toverflow: auto;\n\t}\n\n\t.day-indicators {\n\t\tgap: 2px;\n\t}\n\n\t.day-indicator {\n\t\twidth: 5px;\n\t\theight: 5px;\n\t}\n\n\t.calendar-container {\n\t\tpadding: var(--space-3);\n\t}\n\n\t.calendar-title {\n\t\tfont-size: 12px;\n\t\tline-height: 1.2;\n\t\tmargin: 0 var(--space-1);\t\n\t}\n\n\t.calendar-month-header {\n\t\tfont-size: 18px;\n\t}\n\n\t.calendar-toggle {\n\t\tfont-size: 12px;\n\t\tpadding: 6px 10px;\n\t}\n\n\t.calendar-nav-arrow {\n\t\tfont-size: 14px;\n\t\tpadding: 6px 10px;\n\t}\n\n\t.calendar-days {\n\t\tgap: var(--space-1);\n\t}\n\n\t.calendar-day {\n\t\tmin-height: 52px;\n\t\tpadding: var(--space-1);\n\t}\n\n\t.day-label {\n\t\tfont-size: 10px;\n\t}\n\n\t.day-number {\n\t\tfont-size: 16px;\n\t}\n\n\t.ttbCalendarWeekdayLabel {\n\t\tfont-size: 11px;\n\t}\n\n\t.ttbCalendarWeekDow {\n\t\tfont-size: 11px;\n\t}\n\n\t.ttbCalendarWeekDom {\n\t\tfont-size: 14px;\n\t}\n}\n\n/* ---------- Floor plan-only controls ---------- */\n\n.ttbButtonPrimaryWide {\n\theight: 44px;\n\twidth: 100%;\n\tborder-radius: 12px;\n\tborder: none;\n\tbackground: var(--app-button);\n\tcolor: var(--app-button-text);\n\tfont-weight: 800;\n}\n\n.ttbFloorPlanHint {\n\tcolor: var(--app-hint);\n\tfont-size: 13px;\n}\n\n.ttbFloorPlanFrame {\n\tmargin-top: 12px;\n\tborder-radius: 12px;\n\tborder: 4px solid var(--color-wood-700);\n\toverflow: hidden;\n\tbackground: var(--color-parchment-100);\n\t\n\t/* Parchment texture */\n\tbackground-image: \n\t\tradial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n\t\tradial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n\t\tradial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n\t\trepeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n\t\trepeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n\t\n\tpadding: var(--space-2);\n}\n\n/* SVG план помещений - адаптивный */\n.ttbFloorPlanSvg {\n\twidth: 100%;\n\theight: auto;\n\tdisplay: block;\n\tmax-width: 1200px;\n\tmargin: 0 auto;\n}\n\n.ttbFloorPlanViewport {\n  background: var(--color-parchment-100);\n  \n  /* Parchment texture */\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n}\n\n/* Map Container */\n.map-container {\n  background: var(--color-parchment-100);\n  \n  /* Parchment texture */\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n  \n  border: 4px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  padding: var(--space-4);\n  min-height: 400px;\n  position: relative;\n  overflow: hidden;\n}\n\n.ttbFloorPlanViewport {\n  width: 100%;\n  aspect-ratio: 360 / 260;\n  background: var(--app-bg);\n  position: relative;\n  overflow: hidden;\n  touch-action: none;\n}\n\n.ttbFloorPlanCanvas {\n\tposition: absolute;\n\tinset: 0;\n\ttransform-origin: 0 0;\n}\n\n/* Комнаты */\n.ttbFloorPlanRoomDvor {\n\tposition: absolute;\n\tleft: 2%;\n\ttop: 8%;\n\twidth: 48%;\n\theight: 88%;\n\tborder-radius: 12px;\n\tbackground: rgba(245, 239, 231, 0.3);\n\tborder: 2px solid var(--color-wood-600);\n}\n\n.ttbFloorPlanRoomTavern {\n\tposition: absolute;\n\tleft: 52%;\n\ttop: 8%;\n\twidth: 46%;\n\theight: 88%;\n\tborder-radius: 12px;\n\tbackground: rgba(245, 239, 231, 0.3);\n\tborder: 2px solid var(--color-wood-600);\n}\n\n/* Дверь между комнатами */\n.ttbFloorPlanDoor {\n\tposition: absolute;\n\tleft: 49%;\n\ttop: 35%;\n\twidth: 4%;\n\theight: 12%;\n\tbackground: var(--color-wood-700);\n\tborder: 2px solid var(--color-wood-800);\n\tborder-radius: 6px;\n\tz-index: 2;\n}\n\n.ttbFloorPlanDoor::before {\n\tcontent: '🚪';\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tfont-size: 20px;\n}\n\n.ttbFloorPlanRoomLabel {\n\tposition: absolute;\n\tfont-size: 14px;\n\tcolor: var(--color-wood-700);\n\tfont-weight: 700;\n\tfont-family: var(--font-heading);\n\tuser-select: none;\n\tz-index: 1;\n}\n\n.ttbFloorPlanRoomLabelDvor {\n\tleft: 15%;\n\ttop: 5%;\n}\n\n.ttbFloorPlanRoomLabelTavern {\n\tleft: 65%;\n\tbottom: 8%;\n}\n\n.ttbFloorPlanResource {\n\tposition: absolute;\n\tborder-radius: 10px;\n\tbackground: rgba(245, 239, 231, 0.8);\n\tborder: 3px solid var(--app-success);\n\tpadding: 4px;\n\tcursor: pointer;\n\tcolor: var(--app-text);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 4px;\n\ttransition: all var(--transition-fast);\n\tz-index: 3;\n}\n\n.ttbFloorPlanResource:hover {\n\ttransform: scale(1.05);\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.ttbFloorPlanResource--red {\n\tborder-color: var(--app-danger);\n\tbackground: rgba(168, 52, 42, 0.15);\n}\n\n.ttbFloorPlanResource--yellow {\n\tborder-color: var(--app-warning);\n\tbackground: rgba(212, 167, 74, 0.15);\n}\n\n.ttbFloorPlanResource--green {\n\tborder-color: var(--app-success);\n\tbackground: rgba(74, 124, 89, 0.15);\n}\n\n.ttbFloorPlanResourceIcon {\n\tfont-size: 32px;\n\tline-height: 1;\n\tposition: relative;\n}\n\n/* Стол со стульями - вид сверху */\n.table-with-chairs-big,\n.table-with-chairs-small {\n\twidth: 50px;\n\theight: 50px;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Центральный стол */\n.table-center {\n\twidth: 24px;\n\theight: 24px;\n\tbackground: var(--color-wood-600);\n\tborder: 2px solid var(--color-wood-800);\n\tborder-radius: 4px;\n\tposition: relative;\n\tz-index: 2;\n}\n\n/* Большой стол - 6 стульев вокруг */\n.table-with-chairs-big::before,\n.table-with-chairs-big::after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 8px;\n\theight: 8px;\n\tbackground: var(--color-wood-700);\n\tborder: 1px solid var(--color-wood-900);\n\tborder-radius: 2px;\n}\n\n/* Стулья слева и справа */\n.table-with-chairs-big::before {\n\tleft: 2px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tbox-shadow: 0 -12px 0 0 var(--color-wood-700),\n\t            0 12px 0 0 var(--color-wood-700);\n}\n\n/* Стулья сверху и снизу */\n.table-with-chairs-big::after {\n\tright: 2px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tbox-shadow: 0 -12px 0 0 var(--color-wood-700),\n\t            0 12px 0 0 var(--color-wood-700);\n}\n\n/* Маленький стол - 4 стула */\n.table-with-chairs-small::before,\n.table-with-chairs-small::after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 8px;\n\theight: 8px;\n\tbackground: var(--color-wood-700);\n\tborder: 1px solid var(--color-wood-900);\n\tborder-radius: 2px;\n}\n\n/* Стулья слева и справа */\n.table-with-chairs-small::before {\n\tleft: 4px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n.table-with-chairs-small::after {\n\tright: 4px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n}\n\n/* Дополнительные стулья сверху и снизу через box-shadow */\n.table-with-chairs-small .table-center::before,\n.table-with-chairs-small .table-center::after {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 8px;\n\theight: 8px;\n\tbackground: var(--color-wood-700);\n\tborder: 1px solid var(--color-wood-900);\n\tborder-radius: 2px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.table-with-chairs-small .table-center::before {\n\ttop: -14px;\n}\n\n.table-with-chairs-small .table-center::after {\n\tbottom: -14px;\n}\n\n.ttbFloorPlanResourceCount {\n\tfont-size: 18px;\n\tfont-weight: 800;\n\tline-height: 1;\n\tcolor: var(--color-fire-600);\n}\n\n.ttbFloorPlanResourceName {\n\tfont-size: 9px;\n\tcolor: var(--color-wood-700);\n\tfont-weight: 600;\n\tline-height: 1;\n\ttext-align: center;\n}\n\n/* Layout positions based on actual floor plan (360x260 design space) */\n/* Левая комната (Двор), правая комната (Таверна), дверь посередине */\n\n/* ДВОР - левая комната */\n/* Стол 4 - вверху слева */\n.ttbFloorPlanResource--table_game_4 {\n\tleft: 5.5556%;      /* 20 / 360 */\n\ttop: 11.5385%;      /* 30 / 260 */\n\twidth: 19.4444%;    /* 70 / 360 */\n\theight: 19.2308%;   /* 50 / 260 */\n}\n\n/* Стол настольного тенниса - слева внизу */\n.ttbFloorPlanResource--table_ping_pong_1 {\n\tleft: 5.5556%;      /* 20 / 360 */\n\ttop: 53.8462%;      /* 140 / 260 */\n\twidth: 13.8889%;    /* 50 / 360 */\n\theight: 30.7692%;   /* 80 / 260 */\n}\n\n/* Зона фехтования - центр двора */\n.ttbFloorPlanResource--zone_fencing_1 {\n\tleft: 26.3889%;     /* 95 / 360 */\n\ttop: 46.1538%;      /* 120 / 260 */\n\twidth: 22.2222%;    /* 80 / 360 */\n\theight: 26.9231%;   /* 70 / 260 */\n}\n\n/* ТАВЕРНА - правая комната */\n/* Стол 1 - вверху слева */\n.ttbFloorPlanResource--table_game_1 {\n\tleft: 55.5556%;     /* 200 / 360 */\n\ttop: 11.5385%;      /* 30 / 260 */\n\twidth: 18.0556%;    /* 65 / 360 */\n\theight: 19.2308%;   /* 50 / 260 */\n}\n\n/* Стол 2 - вверху справа */\n.ttbFloorPlanResource--table_game_2 {\n\tleft: 76.3889%;     /* 275 / 360 */\n\ttop: 11.5385%;      /* 30 / 260 */\n\twidth: 18.0556%;    /* 65 / 360 */\n\theight: 19.2308%;   /* 50 / 260 */\n}\n\n/* Стол 3 - под столом 2 (маленький) */\n.ttbFloorPlanResource--table_game_3 {\n\tleft: 79.1667%;     /* 285 / 360 */\n\ttop: 46.1538%;      /* 120 / 260 */\n\twidth: 12.5%;       /* 45 / 360 */\n\theight: 13.4615%;   /* 35 / 260 */\n}\n\n/* Legend */\n.legend {\n  display: flex;\n  gap: var(--space-4);\n  justify-content: center;\n  margin-top: var(--space-4);\n  padding: var(--space-3);\n  background: rgba(245, 239, 231, 0.5);\n  border-radius: var(--radius-md);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  font-size: 13px;\n}\n\n.legend-color {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 2px solid var(--color-wood-700);\n}\n\n.legend-available {\n  background: rgba(74, 124, 89, 0.3);\n}\n\n.legend-partial {\n  background: rgba(212, 167, 74, 0.3);\n}\n\n.legend-occupied {\n  background: rgba(168, 52, 42, 0.3);\n}\n\n@media (max-width: 425px) {\n\t.ttbFloorPlanHint {\n\t\tfont-size: 12px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
